module.exports = __webpack_public_path__ + "static/media/submit-btn-hover.f754fcb0.png";